import axios from 'axios'

const getEnvkvImage = (transactionId: string) => {
  const url = `${process.env.REACT_APP_API_GATEWAY}/envkv-image/${transactionId}`
  return axios.get(url).then((response) => response.data)
}

export { getEnvkvImage }
